<template>
  <div
    class="marker-wrap"
    :style="{ left: marker.posx +'%', top: marker.posy + '%', transform:'translate(-'+anchorX+'%, -'+anchorY+'%)'}"
    :class="['popUpMarker', openClass, mirroredClass, loadedClass]"
    :id="marker.id"
    :data-pin-name="marker.name"
 
  >
    <button
      @mouseover="activateHoverEffect"
      @mouseout="deactivateHoverEffect"
      @click.prevent="handleClick"
      @focus="activateHoverEffect"
      @blur="deactivateHoverEffect"
      @dragstart="handleDragStart"
      @dragend="handleDragEnd"
      :draggable="isDraggable"
      class="popUpMarker__button"
      
    >
      <div class="popUpMarker__pin">
        <div
          :class="['popUpMarker__pin-svg', marker.pinClass]"
          name="pin"
          :id="'pin-'+marker.id"
          :style="{
          width: pinWidth,
          height : pinHeight
      }"
        >
          <ajax-svg
            :svgSrc="typeof marker.pinOverrides !== 'undefined' && marker.pinOverrides.img !== '' ? marker.pinOverrides.img.url : pinSettings.svg.url"
          />
        </div>
        <div
          :class="['popUpMarker__icon-svg', marker.iconClass]"
          :id="'icon-'+marker.id"
          :style="{
          width: iconWidth,
          height : iconHeight,
          left: iconLeft,
      }"
        >
          <ajax-svg :svgSrc="icon.url"/>
        </div>
      </div>
    </button>
    <div
      v-if="marker.name"
      class="popUpMarker__shrink-wrap"
      :style="{pointerEvents: this.isActive ? 'all' : 'none' }"
      @mouseover="handleChildMouseOver"
      @mouseout="deactivateHoverEffect"
    >
      <div class="popUpMarker__text-wrap popUpMarker__text-wrap--name">
        <span class="popUpMarker__text popUpMarker__text--name">{{marker.name}}</span>
      </div>
      <div v-if="marker.teaser" class="popUpMarker__text-wrap popUpMarker__text-wrap--teaser">
        <span class="popUpMarker__text popUpMarker__text--teaser">{{marker.teaser}}</span>
      </div>
    </div>

    <portal to="modal" v-if="modalOpen">
      <modal-info
        :isOpen="modalOpen"
        :modalData="marker.modalData"
        :originEl="getEl()"
        :closeModal="closeModal"
      ></modal-info>
    </portal>
  </div>
</template>

<script>
import Modal from "./Modal.vue";
import AjaxSVG from "./AjaxSvgVuex.vue";
import { hooks } from "../mixins/hooks.js";
export default {
  name: "PopUpMarker",
  components: {
    "ajax-svg": AjaxSVG,
    "modal-info": Modal
  },
  mixins: [hooks],
  data() {
    return {
      isActive: true,
      lastTriggered: Date.now(),
      isLoaded: false,
      isMirrored: false,
      maxWidth: "none",
      width: "auto",
      modalOpen: false,
      inChild: false,
      hoverTimeOut: 0
    };
  },

  computed: {
    anchorX() {
      if (
        typeof this.marker.pinOverrides !== "undefined" &&
        this.marker.pinOverrides.anchorX != 0
      ) {
        return this.marker.pinOverrides.anchorX;
      }
      return this.pinSettings.anchorx;
    },
    anchorY() {
      if (
        typeof this.marker.pinOverrides !== "undefined" &&
        this.marker.pinOverrides.anchorY != 0
      ) {
        return this.marker.pinOverrides.anchorY;
      }
      return this.pinSettings.anchory;
    },

    mainImg() {
      return this.$store.getters.genOpt({ key: "img" });
    },
    pinSettings() {
      return this.$store.getters.genOpt({ key: "pinSettings" });
    },
    openClass() {
      return this.isActive ? "popUpMarker--open" : "";
    },
    clickType() {
      return "ontouchstart" in document.documentElement === true
        ? "tap"
        : "click";
    },
    mirroredClass() {
      return this.isMirrored ? "popUpMarker--mirrored" : "";
    },
    loadedClass() {
      return this.isLoaded ? "popUpMarker--loaded" : "";
    },
    // normalisedX(){
    //     const anchorx = this.marker.pinOverrides.anchorX != 0 ? this.marker.pinOverrides.anchorX : this.pinSettings.anchorx;
    //     const pxToTheLeft = parseInt(this.pinWidth ) * this.pctToFloat(anchorx);
    //     const imgWidth = this.mainImg.width;
    //     const pctToLeft = this.pxTopct(pxToTheLeft,imgWidth);
    //     return this.marker.posx - pctToLeft;
    // },
    // normalisedY(){
    //     const anchory = this.marker.pinOverrides.anchorY != 0 ? this.marker.pinOverrides.anchorY : this.pinSettings.anchory;
    //     const pxUp = parseInt(this.pinHeight ) * this.pctToFloat(anchory);
    //     const imgHeight = this.mainImg.height;
    //     const pctUp = this.pxTopct(pxUp,imgHeight);
    //     return this.marker.posy - pctUp;
    // },
    pinWidth() {
        let pinWidth = 0;
      if (
        typeof this.marker.pinOverrides !== "undefined" &&
        this.marker.pinOverrides.width !== 0
      ) {
        pinWidth = this.marker.pinOverrides.width ;
      } else {
          pinWidth = this.pinSettings.pinWidth
      }
      return parseInt(pinWidth) * this.markerScale + "px";
    },
    pinHeight() {
        let pinHeight = 0;
      if (
        typeof this.marker.pinOverrides !== "undefined" &&
        this.marker.pinOverrides.height !== 0
      ) {
        pinHeight = this.marker.pinOverrides.height ;
      } else {
          pinHeight = this.pinSettings.pinHeight
      }
      return parseInt(pinHeight) * this.markerScale + "px";
    },
    iconWidth() {
      return parseInt(this.marker.iconWidth) * this.markerScale + "px";
    },
    iconHeight() {
      return parseInt(this.marker.iconHeight) * this.markerScale + "px";
    },
    iconLeft() {
      return parseInt(this.pinWidth) / 2 + "px";
    },
    markerScale() {
      return this.marker.pinScale ? this.marker.pinScale : 1;
    },
    icon() {
      if (this.marker.icon && this.marker.icon !== {}) {
        return this.marker.icon;
      } else {
        const catIcon = this.$store.getters.repeaterGroupItem({
          group: "categories",
          key: "icon",
          id: this.marker.category
        });
        return catIcon ? catIcon : {};
      }
    },
    isDraggable() {
      return this.$store.getters.isAdmin;
    }
  },
  methods: {
    getEl() {
      return this.$el;
    },
    openModal() {
      if (this.marker.modalData.img) {
        this.doHook("beforeModalOpen");
        this.modalOpen = true;
        this.doHook("afterModalOpen");
      }
    },
    handleClick() {
      // are we dealing with click or touch?
      if (this.clickType === "click") {
        if (!this.isDraggable) {
          this.doClose();
          this.openModal();
        }
      } else if (this.clickType === "tap") {
        this.toggleOpen();
      }
    },
    handleDragStart() {
      // console.log('dragme')
    },
    handleDragEnd(e) {
      const rect = this.$parent.$el.getBoundingClientRect();
      let mouseX = (((e.clientX - rect.left) / rect.width) * 100).toFixed(2);
      let mouseY = (((e.clientY - rect.top) / rect.height) * 100).toFixed(2);
      let newMarker = this.marker;
      newMarker.posx = mouseX;
      newMarker.posy = mouseY;
      this.$emit("input", newMarker);
    },
    handleChildMouseOver() {
      // console.log('child hover');
      // console.log(this.hoverTimeOut);
      window.clearTimeout(this.hoverTimeOut);
    },
    pctToFloat(pct) {
      return pct / 100;
    },
    pxTopct(px, total) {
      return (px / total) * 100;
    },

    toggleOpen() {
      this.$el.focus();
      const newTrigger = Date.now();
      if (newTrigger - this.lastTriggered > 200) {
        this.lastTriggered = newTrigger;

        if (this.isActive) {
          this.activateHoverEffect();
        } else {
          this.deactivateHoverEffect();
        }
      }
    },
    doOpen() {
      const newTrigger = Date.now();
      if (newTrigger - this.lastTriggered > 200 && !this.isActive) {
        this.lastTriggered = newTrigger;
        this.$root.$emit("closeMarkers", this);
        this.isActive = true;
      }
    },
    doClose() {
      const newTrigger = Date.now();
      if (newTrigger - this.lastTriggered > 200) {
        this.lastTriggered = newTrigger;
        this.isActive = false;
      }
    },
    closeModal() {
      this.doHook("beforeModalClose");
      this.modalOpen = false;
      this.$el.querySelector(".popUpMarker__button").focus();
      setTimeout(() => {
        this.doHook("afterModalClose");
      }, 100);
    },
    activateHoverEffect(e) {
      // console.log('hover');
      this.doHook("beforePinHover");
      this.doOpen();
      this.doHook("afterPinHover");
      // console.log(this.isActive);
    },
    deactivateHoverEffect(e) {
      this.hoverTimeOut = setTimeout(() => {
        this.doHook("beforePinUnhover");
        this.doClose();
        this.doHook("afterPinUnhover");
      }, 200);
    }
  },
  props: ["marker"],
  mounted() {
    this.$root.$on("closeMarkers", () => {
      //document.activeElement.blur();
      //this.deactivateHoverEffect();
      this.doClose();
    });
    //need to figure out some maths for animation
    const pWidth = this.$el.parentElement.parentElement.clientWidth;
    const pOffset = this.$el.parentElement.parentElement.getBoundingClientRect()
      .left;
    if (this.marker.name && this.marker.name !== "") {
      const rect = this.$el
        .querySelector(".popUpMarker__shrink-wrap")
        .getBoundingClientRect();
      if (rect.left - pOffset + rect.width >= pWidth) {
        this.isMirrored = true;
      }
      this.width = rect.width;
      this.maxWidth = rect.width;
    }
    this.isActive = false;
    this.isLoaded = true;

    this.$nextTick(() => {
      this.doHook("pinMounted");
    });
  }
};
</script>

<style scoped lang="scss">
//.marker-wrap{position:absolute; border: 1px solid blue; border-radius: 0;}
.marker-wrap {
  position: absolute;
  border-radius: 0;
}
//button{border:1px solid red;position:relative; background: transparent;padding: 0;border-radius: 50%; width: 30px; height: 30px;}
button {
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/PopUpMarkerVuex.vue